import '@models/util';
import '@util/polyfill';
import '@util/prepareConfig';

import '@debug/tools';
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/800.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/spotlight/styles.css';
import '@monitoring';
import '@serviceWorker/manageServiceWorker';
import 'cross-state/react/register';
import 'normalize.css';
import './app.css';

import { appStatePersist } from '@appState';
import router from '@router';
import { RouterProvider } from '@tanstack/react-router';
import React from 'react';
import { createRoot } from 'react-dom/client';

console.groupCollapsed(
  `%c Mouse Trap UI ${config.VERSION} (${config.BUILDTIME.toISOString()})%c`,
  'color: teal; font-weight: bold',
  'color: initial',
);
console.info('Using config', window.config);
console.groupEnd();

appStatePersist.initialized
  .catch((error) => {
    console.error('Failed to initialize appStatePersist', error);
  })
  .finally(() => {
    createRoot(document.getElementById('root') as HTMLElement).render(
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>,
    );
  });
